import React from "react";
import { Box, Container, Typography } from "@mui/material";

export default function Terms(props) {
  return (
    <Container maxWidth="md">
      <Box my={4}>
        <iframe
          src="https://docs.google.com/document/d/e/2PACX-1vQY9F0oDMyij90uI83OXfjWmRkj8ZEdRzzzxDWdhbhn06NXLZUCir1QDIriYfc8kPTGCWrjTCnUyD_P/pub?embedded=true"
          style={{ width: "100%", height: "1000vh", border: "0" }}
        ></iframe>
      </Box>
    </Container>
  );
}
